// import { AxiosResponse } from 'axios'
import { accessToken, client, guestClient, userClient } from './auth'
// import { GetOrderSheetsOrderSheetNoResponse } from '@shopby/shop-sdk'

interface orderSheet {
  productNo: number
  optionNo: number
  orderCnt: number
}
/**  장바구니 추가 */
export async function postCart(item: any) {
  return await userClient.post(`/cart`, item)
}

/** 장바구니 가져오기 */
export async function getCart() {
  return await userClient.get(`/cart`)
}

/** 장바구니 수정하기 */
export async function putCart(cartNo: number, orderCnt: number) {
  return await userClient.put(`/cart`, [
    {
      cartNo: cartNo,
      orderCnt: orderCnt,
      optionInputs: null,
    },
  ])
}

/** 장바구니 삭제하기 */
export async function deleteCart(cartNo: string) {
  return await userClient.delete(`/cart?cartNo=${cartNo}`)
}

/** 장바구니 기준 최대 쿠폰 할인 조회 */
export async function getCouponsMaximum(cartNo: string) {
  return await userClient.get(`/cart/coupons/maximum?cartNo=${cartNo}`)
}

/** 주문서 최대 쿠폰 할인 조회 */
export async function getOrderMaximum(orderSheetNo: string) {
  return await userClient.post(`/order-sheets/${orderSheetNo}/coupons/maximum`)
}

/** 주문서 작성하기 */
export async function postOrderSheets(cartNo: number[], array: any) {
  if (accessToken) {
    return await userClient.post(`/order-sheets`, {
      products: array,
      productCoupons: null,
      cartNos: cartNo,
      trackingKey: '',
      channelType: '',
    })
  } else {
    return await guestClient.post(`/order-sheets`, {
      products: array,
      productCoupons: null,
      cartNos: cartNo,
      trackingKey: '',
      channelType: '',
    })
  }
}

export async function postUserOrderSheets(cartNo: number[], array: any) {
  return await userClient.post(`/order-sheets`, {
    products: array,
    productCoupons: null,
    cartNos: cartNo,
    trackingKey: '',
    channelType: '',
  })
}

export async function postGuestOrderSheets(cartNo: number[], array: any) {
  return await client.post(`/order-sheets`, {
    products: array,
    productCoupons: null,
    cartNos: cartNo,
    trackingKey: '',
    channelType: '',
  })
}

/** 비회원 장바구니 계산하기 */
export async function postGuestCart(cart: any) {
  return await client.post(`/guest/cart`, cart)
}
/*

/**  */
export async function getOrderSheet(orderSheetNo: number | string) {
  if (accessToken) {
    return await userClient.get(`/order-sheets/${orderSheetNo}`)
  } else {
    return await client.get(`/order-sheets/${orderSheetNo}`)
  }
}
